<template>
    <div class="warehouse-offline-order">
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery
                :col="1"
                class="padding-top-15"
                :value="formData"
                :formdata="getBase"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            v-if="querytype == 'query'"
            theme="gray"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog
        ></compWrapper>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpOrgServiceWarehouseList,
    HttpGetAllCarrierService,
    HttpOfflineOrderLog
} from "@/service/basicdata.js";
export default {
    props: [ 'activeid', 'querytype' ],
    data() {
        return {
            formData: {},
            warehouseList: [],
            carrierServiceList: [],
            logList: [],
            loading: []
        };
    },
    async created() {
        this.loading = true;
        HttpOrgServiceWarehouseList().then(
            (res) => {
                this.warehouseList = (res.data || []).map((item) => {
                    return {
                        value: item.id,
                        label: `${item.code}(${item.title})`,
                    };
                });
            },
            (err) => {
                this.$VMessage.error(err.message);
            }
        );
        HttpGetAllCarrierService().then(
            (res) => {
                this.carrierServiceList = res.data.map((item) => {
                    return {
                        label: `${item.carrierServiceName}(${item.carrierServiceCode})`,
                        value: item.id,
                        attach: {
                            carrierServiceCode: item.carrierServiceCode,
                        },
                    };
                });
            },
            (err) => {
                this.$VMessage.error(err.message);
            }
        );
        await this.getDetail();
        this.loading = false;
    },
    computed: {
        getBase() {
            return [
                {
                    label: "仓库",
                    key: "warehouseId",
                    tag: "Select",
                    options: this.warehouseList,
                },
                {
                    label: "承运商服务",
                    key: "carrierServiceId",
                    tag: "Select",
                    options: this.carrierServiceList,
                    props: {
                        filterable: true,
                    },
                }
            ];
        },
    },
    methods: {
        async getDetail () {
            await HttpOfflineOrderLog({
                id: this.activeid
            }).then(res => {
                this.formData.warehouseId = res.data.warehouseId;
                this.formData.carrierServiceId = res.data.carrierServiceId;
                this.logList = res.data.orderLogList || [];
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
    },
};
</script>

<style>
</style>